import { Injectable } from '@angular/core';

/**
 * FeatureCouponsService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/feature/coupons/coupons.service.ts
 * (legacy AngularJS name 'FeatureCouponsService'). Dependency-free feature-flag
 * descriptor consumed by FeatureService.isEnabled().
 *
 * Internal to FeatureService (injected directly as an Angular 18 class), so it
 * is not downgrade-registered. The legacy module shell stays empty for the
 * FeatureServiceModule dependency graph. Wave 3 item #26.
 */
@Injectable({ providedIn: 'root' })
export class FeatureCouponsService {
  readonly name = 'coupons';
  readonly key = 'enableCoupons';
}
